module.exports = __webpack_public_path__ + "img/logo_wm.48cb01fa.svg";